import AppAutocomplete from '@jumbo/components/Common/formElements/AppAutocomplete';
import { useDebounce } from '@jumbo/utils/commonHelper';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCities } from 'redux/actions/Cities';


export default function CitiesAutocomplete({label, value, handleChange, handleInitialDataChange = () => {}, helperText=""}){
    const dispatch = useDispatch()
    const [searchText, setSearchText] = useState(null)
    const cities = useSelector(state => state.citiesReducer.cities);
    const debounceSearchText = useDebounce(searchText, 500)
    const [city, setCity] = useState(null);

    useEffect(() => {
        if (debounceSearchText && debounceSearchText.length) {
            dispatch(getCities(debounceSearchText))
        }
    },[debounceSearchText])

    return (
        <AppAutocomplete 
            variant="outlined"
            label={label}
            value={city || value}
            options={cities}
            getOptionLabel={option => (option === '' ? option : option.name)}
            helperText={helperText}
            onChangeText={value => { setSearchText(value); ; handleInitialDataChange(value) }}
            onChange={(event, selected) => {handleChange(selected);}}
        />
    )
}